import React, { createContext, useState, useContext } from 'react';

const NavbarContext = createContext(null);

export const NavbarProvider = ({ children }) => {
  const [showNavbar, setShowNavbar] = useState(true);
  const [sidebarExpanded, setSidebarExpanded] = useState(false); // Default to collapsed

  return (
    <NavbarContext.Provider value={{ showNavbar, setShowNavbar, sidebarExpanded, setSidebarExpanded }}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbar = () => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error('useNavbar must be used within a NavbarProvider');
  }
  return context;
};
